/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input,
  Label, Row,
} from 'reactstrap';
import PinModal from '../../components/pin';

const nullableInteger = value => (value === '' || value === null ? null : Number(value));
const nullableString = value => (value === '' || value === null ? null : value);
const inputValue = value => (value === null || value === undefined ? '' : value);

class WebCountryForm extends React.Component {
  constructor(props) {
    super(props);
    const { country } = props;
    this.state = {
      country_id: inputValue(country.country_id),
      ISOcountryCode: inputValue(country.ISOcountryCode),
      name_en: inputValue(country.name_en),
      name_fr: inputValue(country.name_fr),
      name_ar: inputValue(country.name_ar),
      description_en: inputValue(country.description_en),
      description_fr: inputValue(country.description_fr),
      description_ar: inputValue(country.description_ar),
      timezone: inputValue(country.timezone),
      enabled: country.enabled === undefined ? true : Boolean(Number(country.enabled)),
      submitted: false,
    };
    this.failedSubmit = this.failedSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, type } = e.target;
    const value = type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  }

  handleSubmit() {
    const { onSubmit } = this.props;
    const {
      country_id, ISOcountryCode, name_en, name_fr, name_ar,
      description_en, description_fr, description_ar, timezone, enabled,
    } = this.state;
    const body = {
      country_id: nullableInteger(country_id),
      ISOcountryCode: nullableString(ISOcountryCode),
      name_en,
      name_fr,
      name_ar,
      description_en,
      description_fr,
      description_ar,
      timezone: nullableString(timezone),
      enabled: enabled ? 1 : 0,
    };
    onSubmit({ body: JSON.stringify(body) }).then((result) => {
      if (!result.ok) this.setState({ submitted: false });
    });
  }

  failedSubmit() {
    this.setState({ submitted: false });
  }

  render() {
    const {
      country_id, ISOcountryCode, name_en, name_fr, name_ar,
      description_en, description_fr, description_ar, timezone, enabled, submitted,
    } = this.state;
    const {
      cancel, countries, submitLabel, title,
    } = this.props;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal successSubmit={this.handleSubmit} failedSubmit={this.failedSubmit} />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <Form onSubmit={(e) => { e.preventDefault(); this.setState({ submitted: true }); }}>
                <CardHeader><strong>{title}</strong></CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label for="country_id">Original Country</Label>
                    <Input type="select" name="country_id" id="country_id" value={country_id} onChange={e => this.handleChange(e)}>
                      <Fragment>
                        <option value="">None</option>
                        {countries.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                      </Fragment>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="ISOcountryCode">ISO Country Code</Label>
                    <Input type="text" name="ISOcountryCode" id="ISOcountryCode" value={ISOcountryCode} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_en">English Name</Label>
                    <Input type="text" name="name_en" id="name_en" value={name_en} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_fr">French Name</Label>
                    <Input type="text" name="name_fr" id="name_fr" value={name_fr} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_ar">Arabic Name</Label>
                    <Input type="text" name="name_ar" id="name_ar" value={name_ar} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="description_en">English Description</Label>
                    <Input type="textarea" rows="5" name="description_en" id="description_en" value={description_en} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="description_fr">French Description</Label>
                    <Input type="textarea" rows="5" name="description_fr" id="description_fr" value={description_fr} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="description_ar">Arabic Description</Label>
                    <Input type="textarea" rows="5" name="description_ar" id="description_ar" value={description_ar} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="timezone">Timezone Offset</Label>
                    <Input
                      type="text"
                      name="timezone"
                      id="timezone"
                      value={timezone}
                      placeholder="+04:30 or 00:00"
                      pattern="(?:00:00|[+-](?:(?:0\\d|1[0-3]):[0-5]\\d|14:00))"
                      title="Enter a UTC offset such as +04:30, -05:00, or legacy 00:00"
                      maxLength="6"
                      onChange={e => this.handleChange(e)}
                    />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="enabled" checked={enabled} onChange={e => this.handleChange(e)} />
                      {' Enabled'}
                    </Label>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="success">{submitLabel}</Button>
                  {' '}
                  <Button type="button" onClick={cancel} size="sm" color="danger">Cancel</Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

WebCountryForm.propTypes = {
  cancel: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object),
  country: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

WebCountryForm.defaultProps = { countries: [], country: {} };

export default WebCountryForm;
